import axios from 'axios'

const axiosClient = axios.create()

axiosClient.defaults.baseURL = `/api`
axiosClient.defaults.headers.common['Content-Type'] = 'application/json'
axiosClient.defaults.headers.common['Accept'] = 'application/json'

export default axiosClient
